<template>
  <div id="login_sussceed_wrap">
    <headers/>
    <div class="login_sussceed_wrap_form">
      <div class="login_sussceed_wrap_form_img">
        <img :src="change_img" />
      </div>
      <div class="text_susses" :class="{'sussess':sesscs,'erro':erro}">{{data_msg}}</div>
    </div>
    <footers/>
  </div>
</template>
<script>
import headers from "./header.vue";
import footers from "./footers.vue";
import Net_Work from "../apis/network.js";
import axios from "axios";
import Qs from "qs";
axios.defaults.baseURL = Net_Work.publicApi;
axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;
export default {
  name: "loginsucceed",
  components: { headers, footers },
  data() {
    return {
      keys: "",
      data_msg: "",
      sesscs: false,
      erro: false,
      change_img: "",
      imgs: {
        img1: require("../assets/comfirm.png"),
        imgdefault: "",
        img2: require("../assets/error.png")
      }
    };
  },
  created() {},
  mounted() {
    var _this = this;
    this.keys = this.$route.query.key;
    axios
      .get("/s/api/user/active/email", {
        params: {
          key: _this.keys
        }
      })
      .then(function(response) {
        if (response.data.code === 0) {
          _this.data_msg = "";
          _this.erro = false;
          _this.sesscs = true;
          _this.change_img = "";
          _this.change_img = _this.imgs.img1;
          _this.data_msg = response.data.msg;
        } else {
          _this.erro = true;
          _this.sesscs = false;
          _this.change_img = "";
          _this.data_msg = response.data.msg;
          _this.change_img = _this.imgs.img2;
        }
      })
      .catch(function(error) {})
      .then(function() {
        // always executed
      });
  }
};
</script>
<style lang="less" scoped>
.login_sussceed_wrap_form {
  width: 100%;
  padding-bottom: 365px;
  .login_sussceed_wrap_form_img {
    margin-top: 240px;
    display: flex;
    justify-content: center;
    img {
      display: block;
    }
  }
  .text_susses {
    text-align: center;
    margin-top: 22px;
    font-size: 14px;
    letter-spacing: 2px;
    line-height: 18px;
  }
  .sussess {
    color: #409EFF;
  }
  .erro {
    color:#F56C6C;
  }
  .login_wrap_for_enter {
    display: flex;
    justify-content: center;
    margin-top: 45px;
    .login_wrap_for_enter_con {
      width: 260px;
      line-height: 30px;
      background-color: #3366ff;
      font-family: MicrosoftYaHei;
      cursor: pointer;
      font-size: 11px;
      text-align: center;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loginsucceed.vue